function setMainBgOffset () {
  const bannerSection = document.querySelector(
    'section[id$="__slideshow_8MEfh4"]'
  )
  const banner = bannerSection?.querySelector('x-slideshow') || bannerSection
  const main = document.querySelector('main#main.anchor')

  if (!banner || !main) return

  const bannerHeight = banner.getBoundingClientRect().height

  if (bannerHeight > 0) {
    main.style.setProperty('--banner-height', `${bannerHeight}px`)
    main.classList.add('is-bg-ready')
  }
}

/** 源自2026-july活动，页内跳转（#锚点）除外，其余链接新开标签页 */
function forceBSLinksOpenInNewTab () {
  const root = document.querySelector('main#main') || document
  root.querySelectorAll('a[href]').forEach(a => {
    const href = (a.getAttribute('href') || '').trim()
    if (
      !href ||
      href.startsWith('#') ||
      href.startsWith('javascript:') ||
      href.startsWith('mailto:') ||
      href.startsWith('tel:')
    ) {
      return
    }
    a.setAttribute('target', '_blank')
    a.setAttribute('rel', 'noopener noreferrer')
  })
}

function initAutumnRobotCarouselDots () {
  const MOBILE_MAX = 768

  document.querySelectorAll('.section--26autumn-robot [data-autumn-robot-scroll]').forEach(scroller => {
    const dotsWrap = scroller.parentElement?.querySelector('[data-autumn-robot-dots]')
    if (!dotsWrap) return

    const getCards = () => scroller.querySelectorAll('.bs-tab-acc__card')
    const getDots = () => dotsWrap.querySelectorAll('.autumn-robot__dot')

    const syncDotsToCards = () => {
      const cards = getCards()
      const dots = getDots()
      if (window.innerWidth > MOBILE_MAX || cards.length <= 1) {
        dotsWrap.hidden = true
        return
      }
      dotsWrap.hidden = false
      dots.forEach((dot, i) => {
        dot.hidden = i >= cards.length
      })
    }

    const setActiveIndex = index => {
      getDots().forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index)
      })
    }

    const updateActiveFromScroll = () => {
      if (window.innerWidth > MOBILE_MAX) return
      const cards = getCards()
      if (!cards.length) return
      const scrollLeft = scroller.scrollLeft
      let active = 0
      let best = Infinity
      cards.forEach((card, i) => {
        const dist = Math.abs(card.offsetLeft - scrollLeft)
        if (dist < best) {
          best = dist
          active = i
        }
      })
      setActiveIndex(active)
    }

    getDots().forEach(dot => {
      dot.addEventListener('click', () => {
        const i = Number(dot.getAttribute('data-dot-index'))
        const card = getCards()[i]
        if (card) {
          card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' })
        }
      })
    })

    let scrollTick = false
    scroller.addEventListener(
      'scroll',
      () => {
        if (scrollTick) return
        scrollTick = true
        requestAnimationFrame(() => {
          updateActiveFromScroll()
          scrollTick = false
        })
      },
      { passive: true }
    )

    window.addEventListener('resize', () => {
      syncDotsToCards()
      updateActiveFromScroll()
    })

    syncDotsToCards()
    updateActiveFromScroll()
  })
}

window.addEventListener('DOMContentLoaded', () => {
  setMainBgOffset()
  forceBSLinksOpenInNewTab()
  initAutumnRobotCarouselDots()
})
window.addEventListener('load', setMainBgOffset)
window.addEventListener('resize', setMainBgOffset)

setTimeout(setMainBgOffset, 300)
setTimeout(setMainBgOffset, 1000)
